import { helpers, required } from "@vuelidate/validators";

export const sometimes$ = {
    $validator: function(value) {
        return true
    },
    $message: 'Dieses Feld ist erforderlich',
}

export const true$ = {
    $validator: function(value) {
        return (value === true)
    },
    $message: 'Dieses Feld ist erforderlich',
}

export const required$ = helpers.withMessage('Dieses Feld ist erforderlich', required)
